import usePermissions from 'src/shared/hooks/usePermissions';
import { Access, Resources } from 'src/shared/types';

/**
 * Whether the current user may perform the admin organisation and project mutations.
 *
 * Asks about the resource rather than naming a role, so access can be widened from data.
 * A Cognito group already reaches this check: the backend converts groups into synthetic
 * permission rows (`pkg/util/permissions.go` `getGroupPermission`, appended in
 * `getUnCachedUserPermissions`), and `SUPER_ADMIN` receives a wildcard customer with
 * wildcard resources — so a super-admin passes without any grant of its own.
 *
 * The ops-admin role therefore needs no frontend change: granting it this resource, either
 * as a `getGroupPermission` case or a `permissions` row, is enough.
 */
const useCanAdministerOrganisations = (): boolean => {
    const { hasPermission } = usePermissions();

    return hasPermission({
        to: [Access.CREATE, Access.UPDATE],
        resource: Resources.ADMIN_ORG_MANAGEMENT,
    });
};

export default useCanAdministerOrganisations;
